import { render, staticRenderFns } from "./standardFilesRepository.vue?vue&type=template&id=63d4a3ea&scoped=true"
import script from "./standardFilesRepository.vue?vue&type=script&lang=js"
export * from "./standardFilesRepository.vue?vue&type=script&lang=js"
import style0 from "./standardFilesRepository.vue?vue&type=style&index=0&id=63d4a3ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d4a3ea",
  null
  
)

export default component.exports